import React, { useState } from "react";
import { addCrewUser, editCrewUser } from "../API";
import { useParams } from "react-router-dom";
import icon1 from "../assets/images/numberSort.png";
import icon2 from "../assets/images/alphabetSort.png";
import iconAlpha from "../assets/images/alphabetSort-blue.png";
import iconNum from "../assets/images/numberSort-blue.png";
import { toast } from "react-toastify";

const AddProjectCrewUser = ({ onAddNewMember, userOptions }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [hoverImage, setHoverImage] = useState(null);

  const resetState = () => {
    setSelectedRows([]);
    setSortColumn(null);
    setSortOrder("asc");
    setSearchTerm("");
    setHoverImage(null);
  };

  const { crewId } = useParams();

  const onAddNewUser = () => {
    if (selectedRows?.length > 0) {
      selectedRows?.map((ele) => {
        addNewCrewMemberPromise(ele);
      });
      setSelectedRows([]);
    } else {
      toast.warning("No user selected");
    }
  };

  const tableHeading = [
    {
      label: "Select",
    },
    {
      img: icon1,
      label: "Id",
      sortBy: "number",
      hoverImg: iconNum,
    },
    {
      img: icon2,
      label: "Name",
      sortBy: "name",
      hoverImg: iconAlpha,
    },
    {
      label: "Labor Item",
    },
  ];

  const handleMouseEnter = (index) => {
    setHoverImage(index);
  };
  const handleMouseLeave = (index) => {
    setHoverImage(null);
  };

  const handleSort = (column) => {
    setSortColumn(column);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleRowCheckboxChange = (row) => {
    const isSelected = selectedRows.some(
      (selectedRow) => selectedRow.id === row.id
    );

    if (isSelected) {
      setSelectedRows(
        selectedRows.filter((selectedRow) => selectedRow.id !== row.id)
      );
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  const isSelected = (row) =>
    selectedRows.some((selectedRow) => selectedRow.id === row.id);

  const sortedUserList = [...userOptions].sort((a, b) => {
    const valueA = sortColumn === "name" ? a.name : a.id;
    const valueB = sortColumn === "name" ? b.name : b.id;

    if (sortOrder === "asc") {
      return typeof valueA === "string"
        ? valueA.localeCompare(valueB)
        : valueA - valueB;
    } else {
      return typeof valueB === "string"
        ? valueB.localeCompare(valueA)
        : valueB - valueA;
    }
  });

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };
  const handleClick = () => {
    setSearchTerm("");
    setSelectedRows([]);
  };

  const filteredUserList = sortedUserList.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(item.employee_id).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const addNewCrewMemberPromise = async (data) => {
    if (data?.type !== "NA" && data?.crew_user_id !== "NA") {
      const payload = {
        id: data?.crew_user_id,
        data: {
          type: "permanent",
        },
      };
      await editCrewUser(payload).then((res) => {
        if (res?.status === 200) {
          onAddNewMember();
          resetState();
        }
      });
    } else {
      const crewUserPayload = {
        crew_id: crewId,
        user_id: data?.id,
        crew_role_id: 4,
      };
      await addCrewUser(crewUserPayload).then((res) => {
        if (res?.status === 200) {
          onAddNewMember();
          resetState();
        }
      });
    }
  };

  return (
    <>
      <div className="text-end">
        <button
          type="button"
          className="btn primary-btn-outlined mb-4 px-3"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          // onClick={() => onAddCrewClick()}
        >
          + Add Member
        </button>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="exampleModalLabel"
              >
                Add new members to this crew
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleClick}
              ></button>
            </div>
            <div className="modal-body">
              <>
                <div className="search-bar mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
                <div className="table-responsive">
                  <table className="table crew-modal-table table-striped">
                    <thead>
                      <tr>
                        {tableHeading?.length > 0 &&
                          tableHeading?.map((item, index, key) => (
                            <th
                              scope="col"
                              className={`table-heading col-${index}`}
                              key={key}
                            >
                              {item.label}
                              <img
                                onClick={() => handleSort(item.sortBy)}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                                src={
                                  hoverImage === index
                                    ? item.hoverImg
                                    : item.img
                                }
                                className="img-fluid icon ml-3"
                                style={{
                                  display:
                                    index === 0 || index === 3 ? "none" : "",
                                }}
                                alt=""
                              />
                              {/* {item} */}
                            </th>
                          ))}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUserList?.map((item, key) => {
                        return (
                          <>
                            <tr
                              // className={
                              //   selectedUsers.id === item.id ? "activeRow" : ""
                              // }
                              // onClick={() => setSelectedUsers(item)}
                              key={key}
                            >
                              <td>
                                <input
                                  style={{ cursor: "pointer" }}
                                  type="checkbox"
                                  checked={isSelected(item)}
                                  onChange={() => handleRowCheckboxChange(item)}
                                />
                              </td>
                              <td>
                                {item.employee_id ? item.employee_id : "NA"}
                              </td>
                              <td>{item.name}</td>
                              <td>
                                {item.labor_item ? item.labor_item : "NA"}
                              </td>
                              <td className="details-td"></td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            </div>
            <div className="modal-footer">
              <button
                data-bs-dismiss="modal"
                type="button"
                className="primary-btn"
                aria-label="Close"
                onClick={() => onAddNewUser()}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProjectCrewUser;
